import {
  getWeekOfMonth,
  getMonth,
  getWeeksInMonth,
  isSameYear,
} from 'date-fns';

function getWeekIndexFromDay({ currentDate, day, weekStartsOn = 0 }) {
  const currentCalendarMonth = getMonth(currentDate);
  const monthOfDay = getMonth(day);
  const numberWeeksCurrentMonth = getWeeksInMonth(currentDate, {
    weekStartsOn,
  });
  const datesAreInSameYear = isSameYear(currentDate, day);

  const dayBelongsToPreviousMonth =
    datesAreInSameYear && monthOfDay < currentCalendarMonth;
  const dayBelongsToPreviousYear =
    !datesAreInSameYear && monthOfDay > currentCalendarMonth;
  const dayBelongsToNextMonth =
    datesAreInSameYear && monthOfDay > currentCalendarMonth;
  const dayBelongsToNextYear =
    !datesAreInSameYear && monthOfDay < currentCalendarMonth;

  if (dayBelongsToPreviousYear || dayBelongsToPreviousMonth) {
    return 0;
  }
  if (dayBelongsToNextYear || dayBelongsToNextMonth) {
    return numberWeeksCurrentMonth - 1;
  }
  return (
    getWeekOfMonth(day, {
      weekStartsOn,
    }) - 1
  );
}

export default getWeekIndexFromDay;
